<div class="db-migration-progress">
  <div class="db-migration-progress__content">
    <h1 [innerHTML]="'text_migrationInProgressTitle' | dbText"></h1>
    <p [innerHTML]="'text_migrationInProgressDesc' | dbText"></p>
    <div class="db-migration-progress__image-wrap">
      <img src="assets/images/migration/migrate_website_new.png" alt=""/>
    </div>
    <div class="db-migration-progress__loading">
      <div class="db-migration-progress__loading-line-base"></div>
      <div class="db-migration-progress__loading-line"></div>
    </div>

    <div class="db-migration-progress__email">
      <div>
        <i class="db-icon db-icon-ds-bell"></i>
      </div>
      <p>We’ll send you an email notification once the migration<br/> of your website is completed</p>
    </div>
  </div>

  <div class="db-migration-progress__slider">
    <div>
      <h3 [innerHTML]="'text_migrationInProgressSlider' | dbText"></h3>

      <div *ngFor="let slide of slides;  let i = index"
           class="db-migration-progress__slide"
           [ngClass]="{'current': slideCheckedId === slide.id, 'next': slideCheckedId === slide.next}">
        <div class="db-migration-progress__slider-img">
          <img [src]="slide.img" alt=""/>
        </div>
        <h2 [innerHTML]="slide.title"></h2>
        <p [innerHTML]="slide.desc"></p>
      </div>
    </div>
    <div class="db-migration-progress__slide-control-wrap">
      <a class="db-migration-progress__slide-control prev" (click)="prevSlide()" >
        <i class="db-icon db-icon-ds-arrow-small"></i>
      </a>
      <div class="db-migration-progress__slides-count">
        <div *ngFor="let slide of slides;  let i = index"
             (click)="slideCheckedId = i"
             [ngClass]="{'current': slideCheckedId === i}"></div>
      </div>
      <a class="db-migration-progress__slide-control next" (click)="nextSlide()">
        <i class="db-icon db-icon-ds-arrow-small"></i>
      </a>
    </div>
  </div>
</div>
